module.exports = __webpack_public_path__ + "static/scale-model-of-photo-antiquities-in-pittsburgh-pennsylvania-92d39fb77592fba701e4233ad8129570.png";